import React from "react";
import AllData from "../../components/category/table/component";

const Component = () => {
  return <AllData tableHeading="All Category" />;
};

export default Component;
